import { changeSelectedCurrency } from "@/features/auth/duck/auth";
import { Select } from "antd";
import { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import "./CurrencyDropdown.css";

const CurrencyDropdown = ({ options, className }) => {
  const { currencyRateListOptions } = useSelector(
    (state) => ({
      currencyRateListOptions: state.auth.currencyRateListOptions
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const [currencyRate, setCurrencyRate] = useState(
    localStorage.getItem("currency") || "USD"
  );

  const onHandleCurrencySelect = (value) => {
    setCurrencyRate(value);
    localStorage.setItem("currency", value);
    dispatch(changeSelectedCurrency(value));
  };

  const isDisable = Boolean(currencyRateListOptions);

  return (
    <Select
      defaultValue={currencyRate}
      onSelect={onHandleCurrencySelect}
      options={currencyRateListOptions || options}
      disabled={!isDisable}
      className={className}
    />
  );
};

export default CurrencyDropdown;
